import { X_APPL } from '../config/portale-config'

export const onRequestConfig = function (config) {
  const appl = localStorage.getItem(X_APPL)

  if (appl !== undefined)
    config.headers[X_APPL] = appl;
}

export const onRequestConfigError = function (error) {
  console.log(error)
}

export const onNoServerResponse = function (error) {
  console.log(error)
}

export const onResponse = function (response) {

  if (response.headers[X_APPL] !== null && response.headers[X_APPL] !== undefined)
    localStorage.setItem(X_APPL, response.headers[X_APPL])
}

export const onResponseError = function (error) {
  switch (error.response.status) {
    case 400:
      //incongruenza cookie
      this.rootStore.errorStore.error_code = error.response.status
      this.rootStore.routingStore.push('/error')
      break;
    case 403:
      //non autenticato (non dovrebbe capitare se c'è il TAI)
      this.rootStore.errorStore.error_code = error.response.statu
      this.rootStore.routingStore.push('/error')

      this.rootStore.refreshStore(['errorStore', 'userInfoStore'])
      break;
    case 401:
      //non autorizzato (da filtro)
      this.rootStore.errorStore.error_code = error.response.status
      this.rootStore.routingStore.push('/error')

      this.rootStore.refreshStore(['errorStore', 'userInfoStore'])

      break;
    case 409:
      if (error.response.headers[X_APPL] !== null && error.response.headers[X_APPL] !== undefined)
        localStorage.setItem(X_APPL, error.response.headers[X_APPL])

      this.rootStore.refreshStore()
      //Ricarico lo userinfo Store se cambiata l'utenza di lavoro (409) ed il menu
      this.rootStore.userInfoStore.fetchUserInfo();
      this.rootStore.menuStore.fetchMenuItems();

      this.rootStore.routingStore.push(`${ process.env.CONTEXT_PATH }/home`)
      break;
    default:
      //TODO verificare se insieme al codice http di errore ci sia anche un messaggio valorizzato nell'header
      // var msg = "Si è verificato un errore. Contattare l'assistenza.";
      // var msgHeader = error.response.headers.msg;

      // if(msgHeader!==undefined && msgHeader!==null && msgHeader!=="")
      //   msg = msgHeader;

      // this.rootStore.uiStore.addDangerMessage({"text": msg})
      break;
  }
}